import React from 'react';
import { connect } from 'react-redux';


import {
  accountEmailBlur,
  accountEmailChange,
  accountEmailFocus,
  accountEmailSet,
  accountEmailSetValidationMessage
} from 'src/app/redux/actions/registration/account/accountFormEmail';
import PropTypes from 'prop-types';
import Email from 'src/app/components/Email/Email';
import emailPropTypes from 'src/app/propTypes/email';


class AccountFormEmailContainer extends React.PureComponent {
  applySuggestedDomain = (email) => {
    const { dispatch } = this.props;
    dispatch(accountEmailSet(email));
  };

  onBlur = ({ target }) => {
    const { dispatch, markedAsWrong } = this.props;
    const { validationMessage } = target;

    dispatch(accountEmailBlur(markedAsWrong, validationMessage));
    dispatch(accountEmailSetValidationMessage(validationMessage));
  };

  onChange = ({ target }) => {
    const { dispatch, markedAsWrong, apiError } = this.props;
    const { value, validationMessage } = target;

    dispatch(accountEmailChange({
      value,
      validationMessage,
      markedAsWrong,
      apiError
    }));
  };

  onFocus = () => {
    const { dispatch } = this.props;

    dispatch(accountEmailFocus());
  };

  render() {
    const { onBlur, onChange, onFocus, applySuggestedDomain } = this;
    const { value, validationMessage, markedAsWrong, focus, apiError, inputRef, sending } = this.props;

    return (
      <Email
        disabled={ sending }
        {
          ...{
            value,
            validationMessage,
            markedAsWrong,
            focus,
            apiError,
            inputRef,
            onChange,
            onFocus,
            onBlur
          }
        }
        onPickedEmail={ applySuggestedDomain }
        dataTest="input-email"
      />
    );
  }
}

AccountFormEmailContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  ...emailPropTypes,
  inputRef: PropTypes.object.isRequired // eslint-disable-line react/forbid-prop-types
};

const mapStateToProps = (store) => ({
  ...store.accountFormEmailReducer,
  sending: store.accountFormReducer.sending
});

export default connect(mapStateToProps)(AccountFormEmailContainer);
